import { render, staticRenderFns } from "./VirtualPointModal.vue?vue&type=template&id=6462d77e&scoped=true&"
import script from "./VirtualPointModal.vue?vue&type=script&lang=js&"
export * from "./VirtualPointModal.vue?vue&type=script&lang=js&"
import style0 from "./VirtualPointModal.vue?vue&type=style&index=0&id=6462d77e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6462d77e",
  null
  
)

export default component.exports